export default "__VITE_ASSET__CF1MVT6R__"